import { render } from "./TeacherProctorWallView.vue?vue&type=template&id=0bd9e236&scoped=true"
import script from "./TeacherProctorWallView.vue?vue&type=script&lang=js"
export * from "./TeacherProctorWallView.vue?vue&type=script&lang=js"

import "./TeacherProctorWallView.vue?vue&type=style&index=0&id=0bd9e236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd9e236"]])

export default __exports__